import {createRouter, createWebHistory} from "vue-router";
import Login from "@/components/Login.vue";
import ForgotPassword from "@/components/AUTH/forgot_password.vue";
import AddOtpComponent from "@/components/AUTH/add_otp.vue";
import ResetPassword from "@/components/AUTH/reset_password.vue";
import DASHBOARD from "@/components/MAIN_DASHBOARD/main_dashboard.vue";
import App_Bar_and_Navigation_Drawer from "@/components/app_bar_and_navigation_drawer.vue";
import AddProducts from '@/components/PRODUCT_MANAGEMENT/AddProducts.vue';
import addCategory from '@/components/PRODUCT_MANAGEMENT/addCategory.vue';  
import ProductsList from '@/components/PRODUCT_MANAGEMENT/ProductsList.vue';  
import SalesManagement from '@/components/SALES_MANAGEMENT/Sales_Management.vue';  
import CollectionManagement from '@/components/COLLECTION_MANAGEMENT/Collection_Management.vue'; 
import OrganizationManagement from '@/components/OrganizationManagement/ORGANIZATION_MANAGEMENT.vue';  
import AddLeads from "@/components/LeadsManagement/AddLeads.vue";
import LeadsList from "@/components/LeadsManagement/LeadsList.vue";
import UserRegistration from "@/components/UserManagement/UserRegistration.vue";
import UsersList from "@/components/UserManagement/UsersList.vue";
import CreateUserRole from "@/components/UserManagement/CreateUserRole.vue";
import UserRoleList from "@/components/UserManagement/UserRoleList.vue";
import LiveTracking from "@/components/TrackingManagement/LiveTracking.vue";
import TrackingHistory from "@/components/TrackingManagement/TrackingHistory.vue";
import MyrouteTrackingHistary from "@/components/TrackingManagement/NonPlanTrakingHistory.vue";
import CreateRoutes from "@/components/RouteManagement/CreateRoutes.vue";
import RoutesList from "@/components/RouteManagement/RoutesList.vue";
import CreateOutlet from "@/components/OutletManagement/CreateOutlet.vue";
import OutletList from "@/components/OutletManagement/OutletList.vue";
import AllAgents from "@/components/TrackingManagement/AllAgents.vue";
import IdlingAgents from "@/components/TrackingManagement/IdlingAgents.vue";
import ParkingAgents from "@/components/TrackingManagement/ParkingAgents.vue";
import UserLog from "@/components/USER_LOG/userLog.vue";
import CategoryList from "@/components/PRODUCT_MANAGEMENT/CategoryList.vue";
import MeasurementList from "@/components/PRODUCT_MANAGEMENT/measurements.vue";
import OverallTrackingHistory from "@/components/TrackingManagement/OverallTrackingHistory.vue";
import OutletType from "./components/OutletManagement/OutletType.vue";
import CreateOrganization from "./components/OrganizationManagement/CreateOrganization.vue";
import OrganizationList from "./components/OrganizationManagement/OrganizationList.vue"; 
import AttendanceAnalysis from "./components/AttendanceManagement/AttendanceAnalysis.vue";
import TimeManagement from "./components/AttendanceManagement/TimeManagement.vue";
import OvertimeRequest from "./components/AttendanceManagement/OvertimeRequest.vue";
import ApprovedOvertime from "./components/AttendanceManagement/ApprovedOvertime.vue";
import RejectedOvertime from "./components/AttendanceManagement/RejectedOvertime.vue";
import DayInRequest from "./components/AttendanceManagement/DayInRequest.vue";
import ApprovedDayIn from "./components/AttendanceManagement/ApprovedDayIn.vue";
import IndividualClient from "./components/Client_Management/IndividualClient.vue";
import CompanyClient from "./components/Client_Management/CompanyClient.vue";


const routes = [
    { path: '', name: 'Login', component: Login },
    { path: '/login', name: 'Login', component: Login },
    { path: '/forgot_password', component: ForgotPassword },
    { path: '/add_otp', component: AddOtpComponent },
    { path: '/reset-password', component: ResetPassword },
    { path: '', component: App_Bar_and_Navigation_Drawer,
        children: [
            { path: '/dashboard', component: DASHBOARD },
            { path: '/add-products', component: AddProducts },
            { path: '/products-list', component: ProductsList },
            { path: '/products-category', component: addCategory },
            { path: '/category-list', component: CategoryList },
            { path: '/measurement-list', component: MeasurementList },
            { path: '/add-leads', component: AddLeads },
            { path: '/leads-list', component: LeadsList },
            { path: '/user-registration', component: UserRegistration },
            { path: '/users-list', component: UsersList },
            { path: '/create-user-role', component: CreateUserRole },
            { path: '/user-role-list', component: UserRoleList },
            { path: '/sales-management', component: SalesManagement },
            { path: '/collection-management', component: CollectionManagement },
            { path: '/live-tracking', component: LiveTracking },
            { path: '/overall-tracking-history', component: OverallTrackingHistory },
            { path: '/tracking-history', component: TrackingHistory },
            { path: '/myroute-tracking-history', component: MyrouteTrackingHistary },
            { path: '/create-routes', component: CreateRoutes },
            { path: '/routes-list', component: RoutesList },
            { path: '/organization-management', component: OrganizationManagement },
            { path: '/create-outlet', component: CreateOutlet },
            { path: '/outlet-list', component: OutletList },
            { path: '/all-agents', component: AllAgents },
            { path: '/idling-agents', component: IdlingAgents },
            { path: '/parking-agents', component: ParkingAgents},
            { path: '/user-log', component: UserLog },
            { path: '/OutletType', component: OutletType },
            { path: '/create-organization',component: CreateOrganization },
            { path: '/organization-list',component: OrganizationList },
            { path: '/attendance-analysis',component: AttendanceAnalysis },
            { path: '/Time-Management',component: TimeManagement },
            { path: '/Overtime-Request',component: OvertimeRequest },
            { path: '/Approved-Overtime',component: ApprovedOvertime },
            { path: '/Rejected-Overtime',component: RejectedOvertime },
            { path: '/Day-In-request',component: DayInRequest },
            { path: '/Approved-Day-In',component: ApprovedDayIn },
            { path: '/Individual-client',component: IndividualClient }, 
            { path: '/Company-Client',component: CompanyClient },    
        ],
    },

];
const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    const publicRoutes = ['/login', '/forgot_password', '/reset-password' , '/add_otp'];
    if (publicRoutes.includes(to.path)) {
        return next();
    }

    if (!token) {
        return next('/login');
    }

    if (token && to.path === '/login') {
        return next('/dashboard');
    }

    next();
});

export default router
